import PhoneNumber from "../forms/phoneNumber/PhoneNumber";
import {Button} from "antd";
import React, {useEffect, useRef, useState} from "react";
import useUserContext from "../../hooks/useUserContext";
import useAppContext from "../../hooks/useAppContext";
import useToast from "../../hooks/useToast";
import {updatePreviewPhoneNumber} from "../../api/updatePreviewPhoneNumber";
import {ToastSkin} from "../../context/ToastContext";
import "./preview-phone-number.css";

const PreviewPhoneNumber = () => {
    const [phone, setPhone] = useState('');
    const [country, setCountry] = useState('');
    const [phoneWithPrefix, setPhoneWithPrefix] = useState('');
    const { selectedDomain } = useUserContext();
    const { data: { shop } } = useAppContext();
    const { showToast } = useToast();
    const { actions: { loadShop }} = useAppContext();
    const [currentShopPhoneNumber, setCurrentShopPhoneNumber] = useState('');

    useEffect(() => {
        shop.data.previewMessagePhoneNumber && setPhone(shop.data.previewMessagePhoneNumber);
        shop.data.previewMessageCountryCode && setCountry(shop.data.previewMessageCountryCode);
    }, [shop]);

    const onSubmitPreviewPhoneNumber = async () => {
        const fixedPhone = phone ? phone.indexOf('0') === 0 ? phone : `0${phone}` : '';
        selectedDomain && await updatePreviewPhoneNumber(selectedDomain, fixedPhone, country, phoneWithPrefix);
        loadShop();
        showToast({ skin: ToastSkin.approval, text: 'Your phone number was successfully saved. Preview messages will be sent to this number from now on.' });
    }

    const onClearPreviewPhoneNumber = async () => {
        selectedDomain && await updatePreviewPhoneNumber(selectedDomain, null, null, null);
        loadShop();
        // setPhone('');
        // setCountry('');
        // setPhoneWithPrefix('');
        showToast({ skin: ToastSkin.approval, text: 'Your phone number was successfully removed. You cannot send preview messages until you will add a new phone number.' });
    }

    useEffect(() => {
        if(currentShopPhoneNumber !== shop?.data?.previewMessagePhoneNumber) {
            setPhone(shop?.data?.previewMessagePhoneNumber);
            setCurrentShopPhoneNumber(shop?.data?.previewMessagePhoneNumber)
        }
    }, [shop]);

    return (
        <div className="sub-section preview-phone-number">
            <div className="sub-section-title">
                Preview Phone Number
            </div>
            <div className="sub-section-description">
                Set the phone number where you’d like to receive test messages when editing a template.
            </div>
            <div className="sub-section-content">
                <PhoneNumber phone={phone} country={country} onPhoneChange={setPhone} onCountryChange={setCountry} onPhoneWithPrefixChange={setPhoneWithPrefix} />
                <div className="buttons">
                    <Button type="primary" size="large" onClick={onSubmitPreviewPhoneNumber}>Update Preview Phone Number</Button>
                    <Button type="text" size="large" onClick={onClearPreviewPhoneNumber}>Clear Phone Number</Button>
                </div>
            </div>
        </div>
    )
}

export default PreviewPhoneNumber;